import request from '@/utils/request'

// 字典类型API
export const dictTypeApi = {
  // 获取所有字典类型
  list() {
    return request.get('/dict/type/list')
  },

  // 根据ID获取字典类型
  getById(id) {
    return request.get(`/dict/type/${id}`)
  },

  // 添加字典类型
  add(data) {
    return request.post('/dict/type/add', data)
  },

  // 更新字典类型
  update(data) {
    return request.put('/dict/type/update', data)
  },

  // 删除字典类型
  delete(id) {
    return request.delete(`/dict/type/delete/${id}`)
  }
}

// 字典数据API
export const dictDataApi = {
  // 获取所有字典数据
  list() {
    return request.get('/dict/data/list')
  },

  // 根据类型获取字典数据
  listByType(typeCode) {
    return request.get(`/dict/data/listByType/${typeCode}`)
  },

  // 根据ID获取字典数据
  getById(id) {
    return request.get(`/dict/data/${id}`)
  },

  // 添加字典数据
  add(data) {
    return request.post('/dict/data/add', data)
  },

  // 更新字典数据
  update(data) {
    return request.put('/dict/data/update', data)
  },

  // 删除字典数据
  delete(id) {
    return request.delete(`/dict/data/delete/${id}`)
  }
}

// 兼容旧版API（保持向后兼容）
export default dictDataApi
